import $ from 'jquery';
import React, { Component } from 'react';
import "react-datetime/css/react-datetime.css";
import { Redirect } from 'react-router-dom';
import Comm from '../comm/comm';
import Context from '../context/context';
import Translation from '../translation/translation';
import PackingListPrices from './packinglistprices';



class EditSales extends Component {
    sid = Context.GetContext().Sid;
    constructor(props) {
        super(props);
        if (!Comm.ValidSession())
            return;

        this.PackingListsPage = 0;
        this.PageSize = 10;

        var sid = Context.GetContext().Sid;

        var partners = Comm.Partners(sid);
        var all = {
            id: -1,
            name: Translation.Trans("all")
        };
        partners.splice(0, 0, all);
        var packinglists = this.PackingLists();




        this.state = {
            ShowResult: false,
            Partners: partners,
            PackingLists: packinglists,
            mode: "list"

        };

        this.ChangePartner = this.ChangePartner.bind(this);
        this.PackingListPageChange = this.PackingListPageChange.bind(this);
        this.PackingLists = this.PackingLists.bind(this);
        this.Delete = this.Delete.bind(this);
        this.EditAmounts = this.EditAmounts.bind(this);
        this.CancelAmounts = this.CancelAmounts.bind(this);

    }

    ChangePartner() {
        this.PackingListsPage = 0;

        var packinglists = this.PackingLists();
        this.setState({ PackingLists: packinglists });

    }

    PackingListPageChange(inc) {
        this.PackingListsPage += inc;
        var packinglists = this.PackingLists();
        this.setState({ PackingLists: packinglists });

    }

    PackingLists() {
        var sid = Context.GetContext().Sid;
        var partnerId = $("#ddlPartner").val();
        var data = { session: sid, page: this.PackingListsPage, pagesize: this.PageSize };
        if (partnerId !== "-1")
            data.partner = partnerId;
        var packingLists = Comm.PackingLists(data);
        return packingLists;
    }


    Delete(id) {
        if (!window.confirm(Translation.Trans("pleaseconfirm")))
            return;

        var sid = Context.GetContext().Sid;
        Comm.DeletePackingList({ session: sid, id: id });
        this.PackingListsPage = 0;

        var packinglists = this.PackingLists();
        this.setState({ PackingLists: packinglists });


    }


    EditAmounts(id) {
        this.setState({ packingListId: id, mode: "edit" })

    }

    CancelAmounts() {
        this.setState({ mode: "list" })

    }


    render() {

        if (!Comm.ValidSession()) {
            Context.Logout();
            return (<Redirect to="/login" push></Redirect>);
        }

        if (Context.RenderNotOK(this.props.history))
            return null;




        return (
            Context.HasRight("reditsales") ?

                <div className="panel panel-default">
                    <div className="panel-heading">{Translation.Trans("editsales")}</div>
                    <div className="panel-body">

                        {this.state.mode === "list" ?
                            <div className="col-md-12">
                                <div className="col-md-12">
                                    <select id="ddlPartner" className="form-control" onChange={() => this.ChangePartner()}>
                                        {this.state.Partners.map(item => <option value={item.id}>{item.name}</option>)}
                                    </select>
                                </div>
                                <p>&nbsp;</p>
                                <div className="col-md-12">
                                    {this.state.PackingLists.packing_lists ?
                                        <table className="table table-striped">
                                            <tbody>
                                                {

                                                    this.state.PackingLists.packing_lists.map(item =>
                                                        <tr>
                                                            <td>{item.date}</td>
                                                            <td>{item.name}</td>
                                                            <td><a onClick={() => this.EditAmounts(item.id)}><i className="far fa-money-bill-alt"></i></a></td>
                                                            <td><a onClick={() => this.Delete(item.id)}><i className="far fa-trash-alt"></i></a></td>
                                                        </tr>)
                                                }
                                            </tbody>
                                        </table>
                                        : null
                                    }
                                </div>
                                <div className="col-md-1">
                                    {
                                        this.PackingListsPage > 0 ?
                                            <button type="button" className="btn btn-default" onClick={() => this.PackingListPageChange(-1)}>&lt;&lt;</button>
                                            : null
                                    }
                                </div>
                                <div className="col-md-1">
                                    {
                                        (this.PackingListsPage + 1) * this.PageSize < this.state.PackingLists.count ?
                                            <button type="button" className="btn btn-default" onClick={() => this.PackingListPageChange(1)}>&gt;&gt;</button>
                                            :
                                            null
                                    }


                                </div>
                            </div>
                            :
                            <PackingListPrices packingListId={this.state.packingListId} closeFunc={this.CancelAmounts}></PackingListPrices>
                        }

                    </div>
                </div>
                :
                <div>{Translation.Trans("noRights")}</div>
        );
    }

}


export default EditSales;


// WEBPACK FOOTER //
// ./src/pages/editsales.js